import { render, staticRenderFns } from "./modashDataRegistry.vue?vue&type=template&id=1356875e&"
import script from "./modashDataRegistry.vue?vue&type=script&lang=js&"
export * from "./modashDataRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports